<template>
    <b-card class="block__objectiveListProduction">
      <header>
        <!-- TITLE -->
        <p class="title">
          <PuSkeleton :loading="isLoading" :count="1" width='120px'>          
            {{datalists.name}}
          </PuSkeleton>
          </p>
        <!-- TITLE -->
      </header>

      <b-list-group>
        <b-list-group-item v-for="(list,index) of datalists.underMinimas" :key="index">

          <!-- SUBCHILD TITLE -->
          <div class="entete">
            <PuSkeleton :loading="isLoading" :count="1" width='160px'>                
              <div class="title">
                  {{list.name}}
                <div class="icon" v-if="list.underCategorieQualificatif" :class="isPostive(list.value,list.qualificatifValue)">
                  <font-awesome-icon :icon="['far', 'bullseye-arrow']" />
                </div>
              </div>
            </PuSkeleton>
            <PuSkeleton :loading="isLoading" :count="1" width='20px'>
              <div class="number" v-if="list.value != null">{{Math.round(Math.floor(list.value)).toLocaleString()}}</div>
            </PuSkeleton>
          </div>
          <!-- SUBCHILD TITLE -->


          <!-- SUBCHILD -->
          <div class="label">

            <div class="left">

              <PuSkeleton :loading="isLoading" :count="1" width='160px'>
                <div class="title">
                  <b> Condition : </b>{{list.condition}}
                  <div class="icon" v-if="list.ok" :class="list.ok == true ? 'green' : 'red'">
                    <font-awesome-icon :icon="['far', 'bullseye-arrow']" />
                  </div>
                </div>
              </PuSkeleton>
            
            </div>
            <div class="right">
              <PuSkeleton :loading="isLoading" :count="1" width='160px'>
                <span v-if="list.result != null">{{Math.round(Math.floor(list.result)).toLocaleString()}}</span>
                <span v-if="list.result != null">{{list.resultType}}</span>
              </PuSkeleton>
            </div>

            <!-- <div class="result" v-if="subChild.valueStrongSub">
              <PuSkeleton :loading="isLoading" :count="1" width='20px'>
                {{subChild.valueStrongSub}} 
              </PuSkeleton>
            </div> -->

          </div>
          <!-- SUBCHILD -->


        </b-list-group-item>
      </b-list-group>


    </b-card>
</template>


<script>

export default {
name:"wrapperObjectiveListMinima",
  props:{
    lists:{
      type:[Object],
      default: () => {
        return {}
        }
      },
    isLoad:{
      default: true
    }
  },
  data(){
    return {
      isLoading:true,
      datalists: { 
          name:'Production',
          underCategories:[{},{}],
          value:'50' 
        }
    }
  },
  created(){
    this.isLoading = this.isLoad;
    this.datalists = this.lists;
  },
  methods:{
  },
  watch : {
    'isLoad' : function (){
      this.datalists = this.lists;  
      this.isLoading = this.isLoad;
    },    
  },     
}
</script>
